// import React, { useState, useEffect } from 'react';
// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Button,
//     TextField,
//     Typography,
//     Box,
//     LinearProgress,
//     Snackbar,
//     Alert,
//     Chip,
//     Modal,
//     Select,
//     MenuItem,
//     FormControl,
//     IconButton,
//     Tooltip
// } from '@mui/material';
// import dayjs from 'dayjs';
// import { useParams } from 'react-router-dom';
// import { getAllStudentAttendence, markAllStudentAttendence } from 'helpers/attendance_helper';
// import { toast } from 'react-toastify';
// import { STUDENT_ATTENDANCE_EXCEL } from 'helpers/url_helper';
// import { CircularProgress } from '@material-ui/core';
// import EditIcon from '@mui/icons-material/Edit';
// import SaveIcon from '@mui/icons-material/Save';
// import CancelIcon from '@mui/icons-material/Cancel';
// import LockOpenIcon from '@mui/icons-material/LockOpen';

// // IMPORTANT: Match EXACTLY with your database values
// // Your DB shows "PRESENT", "ABSENT" - so "HALFDAY" must also be full word
// const UI_ATTENDANCE_STATUSES = [
//     { value: 'PRESENT', label: 'P', display: 'Present', color: 'success'},
//     { value: 'ABSENT', label: 'A', display: 'Absent', color: 'error' },
//     { value: 'HALFDAY', label: 'HD', display: 'Half Day', color: 'warning' }, // 7 characters
// ];

// // Define user types that can mark past dates
// const ALLOW_PAST_DATE_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager'];
// const ALLOW_EDIT_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager', 'Trainer', 'Tata Trainer'];

// const Attendance = ({ students, batchDetails }) => {
//     const [attendance, setAttendance] = useState({});
//     const [date, setDate] = useState(dayjs());
//     const [loading, setLoading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);
//     const params = useParams();
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'success'
//     });
    
//     // State for edit mode
//     const [isEditing, setIsEditing] = useState(false);
//     const [tempAttendance, setTempAttendance] = useState({});
    
//     // User type state
//     const [userType, setUserType] = useState('');
//     const [canMarkPastDate, setCanMarkPastDate] = useState(false);
//     const [canEditAttendance, setCanEditAttendance] = useState(false);

//     // State for validation
//     const [validationErrors, setValidationErrors] = useState({});

//     // Check user permissions on component mount
//     useEffect(() => {
//         const authUser = JSON.parse(localStorage.getItem('authUser'));
//         const currentUserType = authUser?.userType || '';
//         setUserType(currentUserType);
        
//         // Check if user can mark past dates
//         const canMarkPast = ALLOW_PAST_DATE_USERS.includes(currentUserType);
//         setCanMarkPastDate(canMarkPast);
        
//         // Check if user can edit attendance
//         const canEdit = ALLOW_EDIT_USERS.includes(currentUserType);
//         setCanEditAttendance(canEdit);
//     }, []);

//     // Function to convert UI value to DB value
//     const uiToDbValue = (uiValue) => {
//         const statusObj = UI_ATTENDANCE_STATUSES.find(s => s.value === uiValue);
//         return statusObj ? statusObj.dbValue : 'PRESENT';
//     };

//     // Function to convert DB value to UI value
//     const dbToUiValue = (dbValue) => {
//         if (!dbValue) return 'PRESENT';
        
//         // Convert any format to our UI values
//         const upperDbValue = dbValue.toUpperCase();
        
//         if (upperDbValue === 'PRESENT' || upperDbValue === 'P') return 'PRESENT';
//         if (upperDbValue === 'ABSENT' || upperDbValue === 'A') return 'ABSENT';
//         if (upperDbValue === 'HALFDAY' || upperDbValue === 'HALF_DAY' || upperDbValue === 'H') {
//             return 'HALFDAY';
//         }
        
//         return 'PRESENT';
//     };

//     // Load existing attendance for selected date
//     const fetchAttendanceData = async () => {
//         if (!date || !students || students.length === 0) return;

//         try {
//             setLoading(true);
//             setIsEditing(false);
//             setValidationErrors({});

//             const formattedDate = date.format('YYYY-MM-DD');
//             console.log("Fetching attendance for date:", formattedDate);
            
//             const data = await getAllStudentAttendence(`/${params.id}/${formattedDate}`);
//             console.log("Fetched attendance data:", data);
            
//             const fetchedAttendance = {};
            
//             if (data?.success && data?.result && Array.isArray(data.result)) {
//                 // Create a map of existing attendance records
//                 const attendanceMap = {};
//                 data.result.forEach(record => {
//                     if (record.studentId && record.status) {
//                         attendanceMap[record.studentId] = dbToUiValue(record.status);
//                     }
//                 });
                
//                 // Fill attendance for all students
//                 students.forEach(student => {
//                     fetchedAttendance[student.id] = attendanceMap[student.id] || 'PRESENT';
//                 });
//             } else {
//                 // No attendance records - set default for all students
//                 students.forEach(student => {
//                     fetchedAttendance[student.id] = 'PRESENT';
//                 });
//             }

//             console.log("Setting attendance:", fetchedAttendance);
//             setAttendance(fetchedAttendance);
//             setTempAttendance({...fetchedAttendance});

//         } catch (error) {
//             console.error("Error fetching attendance:", error);
//             showSnackbar('Failed to fetch attendance records', 'error');
//             const defaultAttendance = {};
//             students?.forEach(student => {
//                 defaultAttendance[student.id] = 'PRESENT';
//             });
//             setAttendance(defaultAttendance);
//             setTempAttendance({...defaultAttendance});
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (params.id && students && students.length > 0) {
//             fetchAttendanceData();
//         }
//     }, [date, params.id, students]);

//     const handleStatusChange = (studentId, status) => {
//         if (validationErrors[studentId]) {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors[studentId];
//                 return newErrors;
//             });
//         }

//         if (isEditing) {
//             setTempAttendance(prev => ({
//                 ...prev,
//                 [studentId]: status
//             }));
//         } else {
//             setAttendance(prev => ({
//                 ...prev,
//                 [studentId]: status
//             }));
//         }
//     };

//     const handleSubmit = async () => {
//         try {
//             setSubmitting(true);
//             setValidationErrors({});
            
//             if (!students || students.length === 0) {
//                 toast.error("No students available");
//                 return;
//             }
            
//             const currentData = isEditing ? tempAttendance : attendance;
            
//             // Prepare records for backend
//             const records = students.map(student => {
//                 const uiStatus = currentData[student.id] || 'PRESENT';
//                 const dbStatus = uiToDbValue(uiStatus); // Returns "PRESENT", "ABSENT", or "HALFDAY"
                
//                 console.log(`Student ${student.id}: UI=${uiStatus}, Backend=${dbStatus}`);
                
//                 return {
//                     studentId: student.id,
//                     batchId: parseInt(params.id),
//                     status: dbStatus, // Send "PRESENT", "ABSENT", or "HALFDAY"
//                     date: date.format('YYYY-MM-DD')
//                 };
//             });

//             console.log("Submitting to backend:", JSON.stringify(records, null, 2));
//             console.log("Note: Database expects full words: PRESENT, ABSENT, HALFDAY");
            
//             // Send to backend
//             const response = await markAllStudentAttendence(records);
//             console.log("Response:", response);

//             if (response?.success) {
//                 toast.success(response.message || "Attendance saved successfully!");
                
//                 if (isEditing) {
//                     setAttendance({...tempAttendance});
//                     setIsEditing(false);
//                 }
                
//                 // Refresh attendance data
//                 fetchAttendanceData();
//                 showSnackbar('Attendance saved successfully', 'success');
                
//             } else {
//                 const errorMsg = response?.message || "Failed to save attendance.";
//                 toast.error(errorMsg);
//                 showSnackbar('Failed to save attendance: ' + errorMsg, 'error');
//             }

//         } catch (error) {
//             console.error("Error saving attendance:", error);
//             console.error("Error response data:", error.response?.data);
            
//             let errorMessage = "Error saving attendance. Please try again.";
            
//             if (error.response?.status === 400) {
//                 const errorData = error.response.data;
//                 console.error("Backend validation error:", errorData);
                
//                 // Check for database truncation error
//                 if (errorData.message && errorData.message.includes("Data truncated for column 'status'")) {
//                     errorMessage = "Database error: HALFDAY is too long for status column. Please check database schema.";
//                     toast.error("Database column size issue. Contact administrator.");
//                 }
                
//                 if (errorData.errors) {
//                     const errors = {};
//                     Object.keys(errorData.errors).forEach(key => {
//                         const match = key.match(/records\[(\d+)\]\.(studentId|batchId|status|date)/);
//                         if (match && students[parseInt(match[1])]) {
//                             const studentId = students[parseInt(match[1])].id;
//                             errors[studentId] = errorData.errors[key];
//                         }
//                     });
//                     setValidationErrors(errors);
//                     errorMessage = "Validation error. Please check the attendance data.";
//                 } else if (errorData.message) {
//                     errorMessage = `Error: ${errorData.message}`;
//                 }
//             } else if (error.response?.status === 401) {
//                 errorMessage = "Unauthorized. Please login again.";
//             } else if (error.response?.status === 403) {
//                 errorMessage = "You don't have permission to mark attendance.";
//             } else if (error.response?.status === 404) {
//                 errorMessage = "Batch or student not found.";
//             } else if (error.response?.status === 500) {
//                 errorMessage = "Server error. Please contact administrator.";
//             } else if (error.message) {
//                 errorMessage = `Network error: ${error.message}`;
//             }
            
//             toast.error(errorMessage);
//             showSnackbar(errorMessage, 'error');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const showSnackbar = (message, severity) => {
//         setSnackbar({
//             open: true,
//             message,
//             severity
//         });
//     };

//     const handleCloseSnackbar = () => {
//         setSnackbar(prev => ({ ...prev, open: false }));
//     };

//     const markAll = (statusType) => () => {
//         let statusValue;
//         switch(statusType) {
//             case 'present':
//                 statusValue = 'PRESENT';
//                 break;
//             case 'absent':
//                 statusValue = 'ABSENT';
//                 break;
//             case 'halfday':
//                 statusValue = 'HALFDAY';
//                 break;
//             default:
//                 statusValue = 'PRESENT';
//         }
        
//         const newAttendance = {};
        
//         students?.forEach(student => {
//             newAttendance[student.id] = statusValue;
//         });
        
//         setValidationErrors({});
        
//         if (isEditing) {
//             setTempAttendance(newAttendance);
//         } else {
//             setAttendance(newAttendance);
//         }
//     };

//     // Calculate attendance counts
//     const getAttendanceCounts = () => {
//         const counts = {
//             PRESENT: 0,
//             ABSENT: 0,
//             HALFDAY: 0,
//             TOTAL: students?.length || 0
//         };

//         const currentData = isEditing ? tempAttendance : attendance;
        
//         Object.values(currentData).forEach(status => {
//             if (status && counts[status] !== undefined) {
//                 counts[status]++;
//             }
//         });

//         return counts;
//     };

//     const attendanceCounts = getAttendanceCounts();

//     const handleDateChange = (e) => {
//         const newDate = dayjs(e.target.value);
//         const today = dayjs();
        
//         if (!newDate.isValid()) {
//             toast.error("Invalid date selected");
//             return;
//         }
        
//         if (newDate.isAfter(today, 'day')) {
//             setDate(newDate);
//         } else if (newDate.isBefore(today, 'day')) {
//             if (canMarkPastDate) {
//                 setDate(newDate);
//             } else {
//                 toast.error("You are not authorized to mark attendance for past dates");
//                 setDate(today);
//             }
//         } else {
//             setDate(newDate);
//         }
//     };

//     const [filteredStudents, setFilteredStudents] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const handleSearchChange = (value) => {
//         setSearchTerm(value);

//         if (!value.trim()) {
//             setFilteredStudents(null);
//             return;
//         }

//         const searchLower = value.toLowerCase();
//         const filtered = students?.filter(student =>
//             student.id.toString().includes(searchLower) ||
//             student.firstName.toLowerCase().includes(searchLower) ||
//             student.lastName.toLowerCase().includes(searchLower)
//         );

//         setFilteredStudents(filtered || []);
//     };

//     const studentsToDisplay = filteredStudents !== null ? filteredStudents : students;

//     const downloadStudentAttendanceExcel = async (fromDate, toDate) => {
//         try {
//             const formattedFromDate = fromDate.format('YYYY-MM-DD');
//             const formattedToDate = toDate.format('YYYY-MM-DD');

//             const url = `${STUDENT_ATTENDANCE_EXCEL}${params.id}?fromDate=${formattedFromDate}&toDate=${formattedToDate}`;

//             const response = await fetch(url, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
//                 }
//             });

//             if (!response.ok) {
//                 const errorText = await response.text();
//                 throw new Error(`Failed to download Excel: ${response.status} ${response.statusText} - ${errorText}`);
//             }

//             const blob = await response.blob();
//             const contentDisposition = response.headers.get('Content-Disposition');
//             let filename = `Batch_${batchDetails?.batchName || params.id}_student_attendance.xlsx`;
//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
//                 if (filenameMatch && filenameMatch[1]) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             const blobUrl = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = blobUrl;
//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(blobUrl);

//             console.log('Excel file downloaded successfully!');
//             toast.success('Excel file downloaded successfully!');

//         } catch (error) {
//             console.error('Error downloading Excel file:', error);
//             toast.error(`Error: ${error.message || 'Could not download the Excel file.'}`);
//         }
//     };

//     const [downloadFromDate, setDownloadFromDate] = useState(dayjs());
//     const [downloadToDate, setDownloadToDate] = useState(dayjs());
//     const [openDownloadModal, setOpenDownloadModal] = useState(false);
//     const handleOpenDownloadModal = () => setOpenDownloadModal(true);
//     const handleCloseDownloadModal = () => setOpenDownloadModal(false);
//     const [loader, setLoader] = useState(false);

//     const handleDownloadFromDateChange = (e) => {
//         const newDate = dayjs(e.target.value);
//         if (newDate.isValid() && newDate <= dayjs()) {
//             setDownloadFromDate(newDate);
//         }
//     };
    
//     const handleDownloadToDateChange = (e) => {
//         const newDate = dayjs(e.target.value);
//         if (newDate.isValid() && newDate <= dayjs()) {
//             setDownloadToDate(newDate);
//         }
//     };

//     const handleDownloadExcel = () => {
//         if (!downloadFromDate || !downloadToDate) {
//             toast.error('Please select both From Date and To Date for the download.');
//             return;
//         }
        
//         if (downloadFromDate.isAfter(downloadToDate)) {
//             toast.error('From Date cannot be after To Date.');
//             return;
//         }
        
//         setLoader(true);
//         downloadStudentAttendanceExcel(downloadFromDate, downloadToDate)
//             .then(() => {
//                 handleCloseDownloadModal();
//             })
//             .catch(error => {
//                 console.error("Download failed:", error);
//             })
//             .finally(() => {
//                 setLoader(false);
//             });
//     };

//     const handleEditToggle = () => {
//         if (!canEditAttendance) {
//             toast.error("You are not authorized to edit attendance");
//             return;
//         }
        
//         if (isEditing) {
//             setTempAttendance({...attendance});
//             setIsEditing(false);
//             setValidationErrors({});
//             toast.info("Edit mode cancelled");
//         } else {
//             setTempAttendance({...attendance});
//             setIsEditing(true);
//             toast.info("Edit mode enabled. Select new statuses from dropdown.");
//         }
//     };

//     const getStatusInfo = (studentId) => {
//         const currentData = isEditing ? tempAttendance : attendance;
//         const status = currentData[studentId] || 'PRESENT';
//         const statusObj = UI_ATTENDANCE_STATUSES.find(s => s.value === status);
        
//         if (statusObj) {
//             return {
//                 label: statusObj.label,
//                 display: statusObj.display,
//                 color: statusObj.color,
//                 status: status,
//                 dbValue: statusObj.dbValue
//             };
//         }
        
//         return {
//             label: 'P',
//             display: 'Present',
//             color: 'success',
//             status: 'PRESENT',
//             dbValue: 'PRESENT'
//         };
//     };

//     const getCurrentStatus = (studentId) => {
//         const currentData = isEditing ? tempAttendance : attendance;
//         return currentData[studentId] || 'PRESENT';
//     };

//     const isPastDate = () => {
//         return date.isBefore(dayjs(), 'day');
//     };

//     const getDateRestrictions = () => {
//         if (canMarkPastDate) {
//             return {
//                 min: null,
//                 max: dayjs().format('YYYY-MM-DD')
//             };
//         } else {
//             return {
//                 min: dayjs().format('YYYY-MM-DD'),
//                 max: dayjs().format('YYYY-MM-DD')
//             };
//         }
//     };

//     const dateRestrictions = getDateRestrictions();

//     return (
//         <Paper elevation={3} sx={{ p: 3 }}>
//             {/* User Permissions Info */}
//             <Box sx={{ mb: 2, p: 1.5, bgcolor: 'info.light', borderRadius: 1 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                     <Box>
//                         <Typography variant="subtitle2" component="div" color="info.dark">
//                             <strong>User Role:</strong> {userType || 'Loading...'}
//                         </Typography>
//                         <Typography variant="caption" component="div" color="info.dark">
//                             <strong>Permissions:</strong> 
//                             {canMarkPastDate ? ' Can mark past dates' : ' Cannot mark past dates'}
//                             {canEditAttendance ? ' | Can edit attendance' : ' | Cannot edit attendance'}
//                         </Typography>
//                     </Box>
//                     {isPastDate() && (
//                         <Chip 
//                             icon={<LockOpenIcon />}
//                             label="Past Date Mode" 
//                             color="warning" 
//                             size="small"
//                         />
//                     )}
//                 </Box>
//             </Box>

//             {/* Header Section */}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Typography variant="h5" component="h2">
//                     Student Attendance
//                     {isEditing && (
//                         <Chip 
//                             label="Edit Mode" 
//                             color="warning" 
//                             size="small" 
//                             sx={{ ml: 2, verticalAlign: 'middle' }}
//                         />
//                     )}
//                 </Typography>

//                 <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                     {/* Date Selection */}
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                         <TextField
//                             label="Attendance Date"
//                             type="date"
//                             value={date.format('YYYY-MM-DD')}
//                             onChange={handleDateChange}
//                             InputLabelProps={{
//                                 shrink: true,
//                             }}
//                             inputProps={{
//                                 min: dateRestrictions.min,
//                                 max: dateRestrictions.max
//                             }}
//                             sx={{ width: 200 }}
//                             disabled={loading || submitting}
//                         />
//                         {canMarkPastDate && (
//                             <Tooltip title="You can select past dates">
//                                 <LockOpenIcon 
//                                     sx={{ ml: 1, color: 'success.main' }} 
//                                     fontSize="small"
//                                 />
//                             </Tooltip>
//                         )}
//                     </Box>

//                     {/* Edit Toggle Button */}
//                     <Tooltip title={isEditing ? "Cancel Edit" : canEditAttendance ? "Edit Attendance" : "Edit not allowed for your role"}>
//                         <span>
//                             <IconButton
//                                 onClick={handleEditToggle}
//                                 color={isEditing ? "warning" : "primary"}
//                                 disabled={loading || submitting || !canEditAttendance}
//                             >
//                                 {isEditing ? <CancelIcon /> : <EditIcon />}
//                             </IconButton>
//                         </span>
//                     </Tooltip>

//                     {/* Bulk Actions */}
//                     <Box sx={{ display: 'flex', gap: 1 }}>
//                         <Button
//                             variant="outlined"
//                             onClick={markAll('present')}
//                             size="small"
//                             disabled={loading || submitting || !canEditAttendance}
//                             color="success"
//                         >
//                             Mark All Present
//                         </Button>
//                         <Button
//                             variant="outlined"
//                             onClick={markAll('absent')}
//                             size="small"
//                             disabled={loading || submitting || !canEditAttendance}
//                             color="error"
//                         >
//                             Mark All Absent
//                         </Button>
//                         <Button
//                             variant="outlined"
//                             onClick={markAll('halfday')}
//                             size="small"
//                             disabled={loading || submitting || !canEditAttendance}
//                             color="warning"
//                         >
//                             Mark All Half Day
//                         </Button>
//                     </Box>
                    
//                     {/* Download Excel Button */}
//                     <Button
//                         variant="contained"
//                         onClick={handleOpenDownloadModal}
//                         size="small"
//                         sx={{ ml: 2 }}
//                         disabled={loading}
//                     >
//                         Download Excel
//                     </Button>
//                 </Box>
                
//                 {/* Download Modal */}
//                 <Modal
//                     open={openDownloadModal}
//                     onClose={handleCloseDownloadModal}
//                     aria-labelledby="download-excel-modal-title"
//                     aria-describedby="download-excel-modal-description"
//                 >
//                     <Paper sx={modalStyle}>
//                         <Typography id="download-excel-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
//                             Select Date Range for Excel Download
//                         </Typography>
//                         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
//                             <TextField
//                                 label="From Date"
//                                 type="date"
//                                 value={downloadFromDate.format('YYYY-MM-DD')}
//                                 onChange={handleDownloadFromDateChange}
//                                 InputLabelProps={{ shrink: true }}
//                                 inputProps={{ max: dayjs().format('YYYY-MM-DD') }}
//                                 fullWidth
//                             />
//                             <TextField
//                                 label="To Date"
//                                 type="date"
//                                 value={downloadToDate.format('YYYY-MM-DD')}
//                                 onChange={handleDownloadToDateChange}
//                                 InputLabelProps={{ shrink: true }}
//                                 inputProps={{ max: dayjs().format('YYYY-MM-DD') }}
//                                 fullWidth
//                             />
//                         </Box>
//                         <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
//                             <Button variant="outlined" onClick={handleCloseDownloadModal}>
//                                 Cancel
//                             </Button>
//                             <Button 
//                                 variant="contained"
//                                 onClick={handleDownloadExcel}
//                                 disabled={loader}
//                                 startIcon={loader ? <CircularProgress size={20} /> : null}
//                             >
//                                 {loader ? 'Downloading...' : 'Download'}
//                             </Button>
//                         </Box>
//                     </Paper>
//                 </Modal>
//             </Box>

//             {/* Attendance Summary Chips */}
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//                 <Chip
//                     label={`Present: ${attendanceCounts.PRESENT}`}
//                     color="success"
//                     variant="outlined"
//                 />
//                 <Chip
//                     label={`Absent: ${attendanceCounts.ABSENT}`}
//                     color="error"
//                     variant="outlined"
//                 />
//                 <Chip
//                     label={`Half Day: ${attendanceCounts.HALFDAY}`}
//                     color="warning"
//                     variant="outlined"
//                 />
//                 <Chip
//                     label={`Total: ${attendanceCounts.TOTAL}`}
//                     variant="outlined"
//                 />
//             </Box>

//             {/* Legend Info */}
//             <Box sx={{ mb: 2, p: 1.5, bgcolor: 'info.light', borderRadius: 1 }}>
//                 <Typography variant="body2" component="div" color="info.dark">
//                     <strong>Note:</strong> 
//                     <Chip label="P" color="success" size="small" sx={{ mx: 0.5 }} /> = Present | 
//                     <Chip label="A" color="error" size="small" sx={{ mx: 0.5 }} /> = Absent | 
//                     <Chip label="HD" color="warning" size="small" sx={{ mx: 0.5 }} /> = Half Day
//                 </Typography>
//                 <Typography variant="caption" component="div" color="info.dark" sx={{ mt: 0.5 }}>
//                     <strong>Database Format:</strong> Stored as full words: "PRESENT", "ABSENT", "HALFDAY"
//                 </Typography>
//             </Box>

//             {/* Loading Indicator */}
//             {loading && <LinearProgress />}

//             {/* Search Bar */}
//             <Box display="flex" justifyContent="left" sx={{ mb: 2 }}>
//                 <TextField
//                     label="Search Students"
//                     variant="outlined"
//                     value={searchTerm}
//                     onChange={(e) => handleSearchChange(e.target.value)}
//                     sx={{ width: '400px' }}
//                     disabled={loading}
//                 />
//             </Box>
            
//             {/* Attendance Table */}
//             <TableContainer component={Paper} sx={{ maxHeight: '60vh', overflow: 'auto' }}>
//                 <Table stickyHeader>
//                     <TableHead>
//                         <TableRow>
//                             <TableCell>Student ID</TableCell>
//                             <TableCell>Name</TableCell>
//                             <TableCell>Attendance Status</TableCell>
//                             <TableCell>Database Value</TableCell>
//                             {Object.keys(validationErrors).length > 0 && (
//                                 <TableCell>Validation</TableCell>
//                             )}
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {studentsToDisplay?.length > 0 ? (
//                             studentsToDisplay?.map((student) => {
//                                 const currentStatus = getCurrentStatus(student.id);
//                                 const statusInfo = getStatusInfo(student.id);
//                                 const hasError = validationErrors[student.id];
                                
//                                 return (
//                                     <TableRow key={student.id} sx={{ 
//                                         bgcolor: hasError ? 'error.light' : 'transparent',
//                                         '&:hover': { bgcolor: hasError ? 'error.light' : 'action.hover' }
//                                     }}>
//                                         <TableCell>{student.id}</TableCell>
//                                         <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
//                                         <TableCell>
//                                             {isEditing ? (
//                                                 <FormControl 
//                                                     size="small" 
//                                                     sx={{ minWidth: 120 }}
//                                                     disabled={submitting || !canEditAttendance}
//                                                     error={!!hasError}
//                                                 >
//                                                     <Select
//                                                         value={currentStatus}
//                                                         onChange={(e) => handleStatusChange(student.id, e.target.value)}
//                                                         displayEmpty
//                                                     >
//                                                         {UI_ATTENDANCE_STATUSES.map((status) => (
//                                                             <MenuItem 
//                                                                 key={status.value} 
//                                                                 value={status.value}
//                                                             >
//                                                                 {status.label} - {status.display}
//                                                             </MenuItem>
//                                                         ))}
//                                                     </Select>
//                                                 </FormControl>
//                                             ) : (
//                                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                     <Chip
//                                                         label={statusInfo.label}
//                                                         color={statusInfo.color}
//                                                         variant="filled"
//                                                         size="small"
//                                                     />
//                                                     <Typography variant="body2">
//                                                         {statusInfo.display}
//                                                     </Typography>
//                                                 </Box>
//                                             )}
//                                         </TableCell>
//                                         <TableCell>
//                                             <Tooltip title="Stored in database">
//                                                 <Chip
//                                                     label={statusInfo.dbValue}
//                                                     color={statusInfo.color}
//                                                     variant="outlined"
//                                                     size="small"
//                                                 />
//                                             </Tooltip>
//                                         </TableCell>
//                                         {Object.keys(validationErrors).length > 0 && (
//                                             <TableCell>
//                                                 {hasError && (
//                                                     <Typography variant="caption" color="error">
//                                                         {validationErrors[student.id]}
//                                                     </Typography>
//                                                 )}
//                                             </TableCell>
//                                         )}
//                                     </TableRow>
//                                 );
//                             })
//                         ) : (
//                             <TableRow>
//                                 <TableCell colSpan={Object.keys(validationErrors).length > 0 ? 5 : 4} align="center">
//                                     {filteredStudents?.length === 0 ? 'No matching students found' : 'No students available'}
//                                 </TableCell>
//                             </TableRow>
//                         )}
//                     </TableBody>
//                 </Table>
//             </TableContainer>

//             {/* Validation Errors */}
//             {Object.keys(validationErrors).length > 0 && (
//                 <Box sx={{ mt: 2, p: 2, bgcolor: 'error.light', borderRadius: 1 }}>
//                     <Typography variant="body2" color="error.dark">
//                         <strong>Validation Errors:</strong> Please fix the highlighted errors before saving.
//                     </Typography>
//                     <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
//                         {Object.entries(validationErrors).map(([studentId, error]) => {
//                             const student = students?.find(s => s.id == studentId);
//                             return (
//                                 <li key={studentId}>
//                                     <Typography variant="caption" color="error.dark">
//                                         {student ? `${student.firstName} ${student.lastName}: ` : 'Student '}
//                                         {error}
//                                     </Typography>
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </Box>
//             )}

//             {/* Footer Actions */}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
//                 <Box>
//                     {isEditing && (
//                         <Typography variant="body2" component="div" color="warning.main">
//                             <strong>Note:</strong> You are in edit mode. Changes will be saved when you click "Update Attendance"
//                         </Typography>
//                     )}
//                     {isPastDate() && (
//                         <Typography variant="body2" component="div" color="warning.main">
//                             <strong>Warning:</strong> You are marking attendance for a past date ({date.format('DD MMM YYYY')})
//                         </Typography>
//                     )}
//                 </Box>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                     {isEditing && (
//                         <Button
//                             variant="outlined"
//                             onClick={handleEditToggle}
//                             disabled={loading || submitting}
//                             startIcon={<CancelIcon />}
//                         >
//                             Cancel Edit
//                         </Button>
//                     )}
//                     <Button
//                         variant="contained"
//                         onClick={handleSubmit}
//                         disabled={loading || submitting || !canEditAttendance || Object.keys(validationErrors).length > 0}
//                         size="large"
//                         startIcon={isEditing ? <SaveIcon /> : null}
//                         color={isEditing ? "warning" : "primary"}
//                     >
//                         {submitting ? 'Saving...' : isEditing ? 'Update Attendance' : 'Save Attendance'}
//                     </Button>
//                 </Box>
//             </Box>

//             {/* Snackbar for notifications */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//             >
//                 <Alert
//                     onClose={handleCloseSnackbar}
//                     severity={snackbar.severity}
//                     sx={{ width: '100%' }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// };

// const modalStyle = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 400,
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
// };

// export default Attendance;




import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TextField,
    Typography,
    Box,
    LinearProgress,
    Snackbar,
    Alert,
    Chip,
    Modal,
    Select,
    MenuItem,
    FormControl,
    IconButton,
    Tooltip
} from '@mui/material';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { getAllStudentAttendence, markAllStudentAttendence } from 'helpers/attendance_helper';
import { toast } from 'react-toastify';
import { STUDENT_ATTENDANCE_EXCEL } from 'helpers/url_helper';
import { CircularProgress } from '@material-ui/core';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const UI_ATTENDANCE_STATUSES = [
    { value: 'PRESENT', label: 'P', display: 'Present', color: 'success'},
    { value: 'ABSENT', label: 'A', display: 'Absent', color: 'error' },
    { value: 'HALFDAY', label: 'HD', display: 'Half Day', color: 'warning' },
];

const ALLOW_PAST_DATE_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager'];
const ALLOW_EDIT_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager', 'Trainer', 'Tata Trainer'];

const Attendance = ({ students, batchDetails }) => {
    const [attendance, setAttendance] = useState({});
    const [date, setDate] = useState(dayjs());
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const params = useParams();
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });
    
    const [isEditing, setIsEditing] = useState(false);
    const [tempAttendance, setTempAttendance] = useState({});
    const [userType, setUserType] = useState('');
    const [canMarkPastDate, setCanMarkPastDate] = useState(false);
    const [canEditAttendance, setCanEditAttendance] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [filteredStudents, setFilteredStudents] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [downloadFromDate, setDownloadFromDate] = useState(dayjs());
    const [downloadToDate, setDownloadToDate] = useState(dayjs());
    const [openDownloadModal, setOpenDownloadModal] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const currentUserType = authUser?.userType || '';
        setUserType(currentUserType);
        
        setCanMarkPastDate(ALLOW_PAST_DATE_USERS.includes(currentUserType));
        setCanEditAttendance(ALLOW_EDIT_USERS.includes(currentUserType));
    }, []);

    const dbToUiValue = (dbValue) => {
        if (!dbValue) return 'PRESENT';
        
        const upperDbValue = dbValue.toUpperCase();
        
        if (upperDbValue === 'PRESENT' || upperDbValue === 'P') return 'PRESENT';
        if (upperDbValue === 'ABSENT' || upperDbValue === 'A') return 'ABSENT';
        if (upperDbValue === 'HALFDAY' || upperDbValue === 'HALF_DAY' || upperDbValue === 'H') {
            return 'HALFDAY';
        }
        
        return 'PRESENT';
    };

    const fetchAttendanceData = async () => {
        if (!date || !students || students.length === 0) return;

        try {
            setLoading(true);
            setIsEditing(false);
            setValidationErrors({});

            const formattedDate = date.format('YYYY-MM-DD');
            const data = await getAllStudentAttendence(`/${params.id}/${formattedDate}`);
            const fetchedAttendance = {};
            
            if (data?.success && data?.result && Array.isArray(data.result)) {
                const attendanceMap = {};
                data.result.forEach(record => {
                    if (record.studentId && record.status) {
                        attendanceMap[record.studentId] = dbToUiValue(record.status);
                    }
                });
                
                students.forEach(student => {
                    fetchedAttendance[student.id] = attendanceMap[student.id] || 'ABSENT';
                });
            } else {
                students.forEach(student => {
                    fetchedAttendance[student.id] = 'ABSENT';
                });
            }

            setAttendance(fetchedAttendance);
            setTempAttendance({...fetchedAttendance});

        } catch (error) {
            const defaultAttendance = {};
            students?.forEach(student => {
                defaultAttendance[student.id] = 'ABSENT';
            });
            setAttendance(defaultAttendance);
            setTempAttendance({...defaultAttendance});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (params.id && students && students.length > 0) {
            fetchAttendanceData();
        }
    }, [date, params.id, students]);

    const handleStatusChange = (studentId, status) => {
        if (validationErrors[studentId]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[studentId];
                return newErrors;
            });
        }

        if (isEditing) {
            setTempAttendance(prev => ({
                ...prev,
                [studentId]: status
            }));
        } else {
            setAttendance(prev => ({
                ...prev,
                [studentId]: status
            }));
        }
    };

    const handleSubmit = async () => {
        try {
            setSubmitting(true);
            setValidationErrors({});
            
            if (!students || students.length === 0) {
                toast.error("No students available");
                return;
            }
            
            const currentData = isEditing ? tempAttendance : attendance;
            const records = students.map(student => ({
                studentId: student.id,
                batchId: parseInt(params.id),
                status: currentData[student.id] || 'ABSENT',
                date: date.format('YYYY-MM-DD')
            }));

            const response = await markAllStudentAttendence(records);

            if (response?.success) {
                toast.success(response.message || "Attendance saved successfully!");
                
                if (isEditing) {
                    setAttendance({...tempAttendance});
                    setIsEditing(false);
                }
                
                fetchAttendanceData();
                showSnackbar('Attendance saved successfully', 'success');
                
            } else {
                const errorMsg = response?.message || "Failed to save attendance.";
                toast.error(errorMsg);
            }

        } catch (error) {
            let errorMessage = "Error saving attendance. Please try again.";
            
            if (error.response?.status === 400) {
                const errorData = error.response.data;
                
                if (errorData.errors) {
                    const errors = {};
                    Object.keys(errorData.errors).forEach(key => {
                        const match = key.match(/records\[(\d+)\]\.(studentId|batchId|status|date)/);
                        if (match && students[parseInt(match[1])]) {
                            const studentId = students[parseInt(match[1])].id;
                            errors[studentId] = errorData.errors[key];
                        }
                    });
                    setValidationErrors(errors);
                    errorMessage = "Validation error. Please check the attendance data.";
                } else if (errorData.message) {
                    errorMessage = `Error: ${errorData.message}`;
                }
            } else if (error.response?.status === 401) {
                errorMessage = "Unauthorized. Please login again.";
            } else if (error.response?.status === 403) {
                errorMessage = "You don't have permission to mark attendance.";
            } else if (error.response?.status === 404) {
                errorMessage = "Batch or student not found.";
            } else if (error.response?.status === 500) {
                errorMessage = "Server error. Please contact administrator.";
            } else if (error.message) {
                errorMessage = `Network error: ${error.message}`;
            }
            
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const markAll = (statusType) => () => {
        let statusValue;
        switch(statusType) {
            case 'present':
                statusValue = 'PRESENT';
                break;
            case 'absent':
                statusValue = 'ABSENT';
                break;
            case 'halfday':
                statusValue = 'HALFDAY';
                break;
            default:
                statusValue = 'ABSENT';
        }
        
        const newAttendance = {};
        students?.forEach(student => {
            newAttendance[student.id] = statusValue;
        });
        
        setValidationErrors({});
        
        if (isEditing) {
            setTempAttendance(newAttendance);
        } else {
            setAttendance(newAttendance);
        }
    };

    const getAttendanceCounts = () => {
        const counts = {
            PRESENT: 0,
            ABSENT: 0,
            HALFDAY: 0,
            TOTAL: students?.length || 0
        };

        const currentData = isEditing ? tempAttendance : attendance;
        
        Object.values(currentData).forEach(status => {
            if (status && counts[status] !== undefined) {
                counts[status]++;
            }
        });

        return counts;
    };

    const attendanceCounts = getAttendanceCounts();

    const handleDateChange = (e) => {
        const newDate = dayjs(e.target.value);
        const today = dayjs();
        
        if (!newDate.isValid()) {
            toast.error("Invalid date selected");
            return;
        }
        
        if (newDate.isAfter(today, 'day')) {
            setDate(newDate);
        } else if (newDate.isBefore(today, 'day')) {
            if (canMarkPastDate) {
                setDate(newDate);
            } else {
                toast.error("You are not authorized to mark attendance for past dates");
                setDate(today);
            }
        } else {
            setDate(newDate);
        }
    };

    const handleSearchChange = (value) => {
        setSearchTerm(value);

        if (!value.trim()) {
            setFilteredStudents(null);
            return;
        }

        const searchLower = value.toLowerCase();
        const filtered = students?.filter(student =>
            student.id.toString().includes(searchLower) ||
            student.firstName.toLowerCase().includes(searchLower) ||
            student.lastName.toLowerCase().includes(searchLower)
        );

        setFilteredStudents(filtered || []);
    };

    const studentsToDisplay = filteredStudents !== null ? filteredStudents : students;

    const downloadStudentAttendanceExcel = async (fromDate, toDate) => {
        try {
            const formattedFromDate = fromDate.format('YYYY-MM-DD');
            const formattedToDate = toDate.format('YYYY-MM-DD');

            const url = `${STUDENT_ATTENDANCE_EXCEL}${params.id}?fromDate=${formattedFromDate}&toDate=${formattedToDate}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to download Excel: ${response.status} ${response.statusText} - ${errorText}`);
            }

            const blob = await response.blob();
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = `Batch_${batchDetails?.batchName || params.id}_student_attendance.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            toast.success('Excel file downloaded successfully!');

        } catch (error) {
            toast.error(`Error: ${error.message || 'Could not download the Excel file.'}`);
        }
    };

    const handleOpenDownloadModal = () => setOpenDownloadModal(true);
    const handleCloseDownloadModal = () => setOpenDownloadModal(false);

    const handleDownloadFromDateChange = (e) => {
        const newDate = dayjs(e.target.value);
        if (newDate.isValid() && newDate <= dayjs()) {
            setDownloadFromDate(newDate);
        }
    };
    
    const handleDownloadToDateChange = (e) => {
        const newDate = dayjs(e.target.value);
        if (newDate.isValid() && newDate <= dayjs()) {
            setDownloadToDate(newDate);
        }
    };

    const handleDownloadExcel = () => {
        if (!downloadFromDate || !downloadToDate) {
            toast.error('Please select both From Date and To Date for the download.');
            return;
        }
        
        if (downloadFromDate.isAfter(downloadToDate)) {
            toast.error('From Date cannot be after To Date.');
            return;
        }
        
        setLoader(true);
        downloadStudentAttendanceExcel(downloadFromDate, downloadToDate)
            .then(() => {
                handleCloseDownloadModal();
            })
            .catch(error => {
                console.error("Download failed:", error);
            })
            .finally(() => {
                setLoader(false);
            });
    };

    const handleEditToggle = () => {
        if (!canEditAttendance) {
            toast.error("You are not authorized to edit attendance");
            return;
        }
        
        if (isEditing) {
            setTempAttendance({...attendance});
            setIsEditing(false);
            setValidationErrors({});
            toast.info("Edit mode cancelled");
        } else {
            setTempAttendance({...attendance});
            setIsEditing(true);
            toast.info("Edit mode enabled");
        }
    };

    const getStatusInfo = (studentId) => {
        const currentData = isEditing ? tempAttendance : attendance;
        const status = currentData[studentId] || 'ABSENT';
        const statusObj = UI_ATTENDANCE_STATUSES.find(s => s.value === status);
        
        if (statusObj) {
            return {
                label: statusObj.label,
                display: statusObj.display,
                color: statusObj.color,
                status: status
            };
        }
        
        return {
            label: 'P',
            display: 'Present',
            color: 'success',
            status: 'PRESENT'
        };
    };

    const getCurrentStatus = (studentId) => {
        const currentData = isEditing ? tempAttendance : attendance;
        return currentData[studentId] || 'PRESENT';
    };

    const isPastDate = () => {
        return date.isBefore(dayjs(), 'day');
    };

    const getDateRestrictions = () => {
        if (canMarkPastDate) {
            return {
                min: null,
                max: dayjs().format('YYYY-MM-DD')
            };
        } else {
            return {
                min: dayjs().format('YYYY-MM-DD'),
                max: dayjs().format('YYYY-MM-DD')
            };
        }
    };

    const dateRestrictions = getDateRestrictions();

    return (
        <Paper elevation={3} sx={{ p: 3 }}>
            <Box sx={{ mb: 2, p: 1.5, bgcolor: 'info.light', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="subtitle2" component="div" color="info.dark">
                            <strong>User Role:</strong> {userType || 'Loading...'}
                        </Typography>
                        <Typography variant="caption" component="div" color="info.dark">
                            <strong>Permissions:</strong> 
                            {canMarkPastDate ? ' Can mark past dates' : ' Cannot mark past dates'}
                            {canEditAttendance ? ' | Can edit attendance' : ' | Cannot edit attendance'}
                        </Typography>
                    </Box>
                    {isPastDate() && (
                        <Chip 
                            icon={<LockOpenIcon />}
                            label="Past Date Mode" 
                            color="warning" 
                            size="small"
                        />
                    )}
                </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" component="h2">
                    Student Attendance
                    {isEditing && (
                        <Chip 
                            label="Edit Mode" 
                            color="warning" 
                            size="small" 
                            sx={{ ml: 2, verticalAlign: 'middle' }}
                        />
                    )}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TextField
                            label="Attendance Date"
                            type="date"
                            value={date.format('YYYY-MM-DD')}
                            onChange={handleDateChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                min: dateRestrictions.min,
                                max: dateRestrictions.max
                            }}
                            sx={{ width: 200 }}
                            disabled={loading || submitting}
                        />
                        {canMarkPastDate && (
                            <Tooltip title="You can select past dates">
                                <LockOpenIcon 
                                    sx={{ ml: 1, color: 'success.main' }} 
                                    fontSize="small"
                                />
                            </Tooltip>
                        )}
                    </Box>

                    <Tooltip title={isEditing ? "Cancel Edit" : canEditAttendance ? "Edit Attendance" : "Edit not allowed for your role"}>
                        <span>
                            <IconButton
                                onClick={handleEditToggle}
                                color={isEditing ? "warning" : "primary"}
                                disabled={loading || submitting || !canEditAttendance}
                            >
                                {isEditing ? <CancelIcon /> : <EditIcon />}
                            </IconButton>
                        </span>
                    </Tooltip>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            variant="outlined"
                            onClick={markAll('present')}
                            size="small"
                            disabled={loading || submitting || !canEditAttendance}
                            color="success"
                        >
                            Mark All Present
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={markAll('absent')}
                            size="small"
                            disabled={loading || submitting || !canEditAttendance}
                            color="error"
                        >
                            Mark All Absent
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={markAll('halfday')}
                            size="small"
                            disabled={loading || submitting || !canEditAttendance}
                            color="warning"
                        >
                            Mark All Half Day
                        </Button>
                    </Box>
                    
                    <Button
                        variant="contained"
                        onClick={handleOpenDownloadModal}
                        size="small"
                        sx={{ ml: 2 }}
                        disabled={loading}
                    >
                        Download Excel
                    </Button>
                </Box>
                
                <Modal
                    open={openDownloadModal}
                    onClose={handleCloseDownloadModal}
                    aria-labelledby="download-excel-modal-title"
                >
                    <Paper sx={modalStyle}>
                        <Typography id="download-excel-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                            Select Date Range for Excel Download
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
                            <TextField
                                label="From Date"
                                type="date"
                                value={downloadFromDate.format('YYYY-MM-DD')}
                                onChange={handleDownloadFromDateChange}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: dayjs().format('YYYY-MM-DD') }}
                                fullWidth
                            />
                            <TextField
                                label="To Date"
                                type="date"
                                value={downloadToDate.format('YYYY-MM-DD')}
                                onChange={handleDownloadToDateChange}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ max: dayjs().format('YYYY-MM-DD') }}
                                fullWidth
                            />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Button variant="outlined" onClick={handleCloseDownloadModal}>
                                Cancel
                            </Button>
                            <Button 
                                variant="contained"
                                onClick={handleDownloadExcel}
                                disabled={loader}
                                startIcon={loader ? <CircularProgress size={20} /> : null}
                            >
                                {loader ? 'Downloading...' : 'Download'}
                            </Button>
                        </Box>
                    </Paper>
                </Modal>
            </Box>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                <Chip
                    label={`Present: ${attendanceCounts.PRESENT}`}
                    color="success"
                    variant="outlined"
                />
                <Chip
                    label={`Absent: ${attendanceCounts.ABSENT}`}
                    color="error"
                    variant="outlined"
                />
                <Chip
                    label={`Half Day: ${attendanceCounts.HALFDAY}`}
                    color="warning"
                    variant="outlined"
                />
                <Chip
                    label={`Total: ${attendanceCounts.TOTAL}`}
                    variant="outlined"
                />
            </Box>

            <Box sx={{ mb: 2, p: 1.5, bgcolor: 'info.light', borderRadius: 1 }}>
                <Typography variant="body2" component="div" color="info.dark">
                    <strong>Note:</strong> 
                    <Chip label="P" color="success" size="small" sx={{ mx: 0.5 }} /> = Present | 
                    <Chip label="A" color="error" size="small" sx={{ mx: 0.5 }} /> = Absent | 
                    <Chip label="HD" color="warning" size="small" sx={{ mx: 0.5 }} /> = Half Day
                </Typography>
            </Box>

            {loading && <LinearProgress />}

            <Box display="flex" justifyContent="left" sx={{ mb: 2 }}>
                <TextField
                    label="Search Students"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    sx={{ width: '400px' }}
                    disabled={loading}
                />
            </Box>
            
            <TableContainer component={Paper} sx={{ maxHeight: '60vh', overflow: 'auto' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Student ID</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Attendance Status</TableCell>
                            {Object.keys(validationErrors).length > 0 && (
                                <TableCell>Validation</TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {studentsToDisplay?.length > 0 ? (
                            studentsToDisplay?.map((student) => {
                                const currentStatus = getCurrentStatus(student.id);
                                const statusInfo = getStatusInfo(student.id);
                                const hasError = validationErrors[student.id];
                                
                                return (
                                    <TableRow key={student.id} sx={{ 
                                        bgcolor: hasError ? 'error.light' : 'transparent',
                                        '&:hover': { bgcolor: hasError ? 'error.light' : 'action.hover' }
                                    }}>
                                        <TableCell>{student.id}</TableCell>
                                        <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
                                        <TableCell>
                                            {isEditing ? (
                                                <FormControl 
                                                    size="small" 
                                                    sx={{ minWidth: 120 }}
                                                    disabled={submitting || !canEditAttendance}
                                                    error={!!hasError}
                                                >
                                                    <Select
                                                        value={currentStatus}
                                                        onChange={(e) => handleStatusChange(student.id, e.target.value)}
                                                        displayEmpty
                                                    >
                                                        {UI_ATTENDANCE_STATUSES.map((status) => (
                                                            <MenuItem 
                                                                key={status.value} 
                                                                value={status.value}
                                                            >
                                                                {status.label} - {status.display}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            ) : (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Chip
                                                        label={statusInfo.label}
                                                        color={statusInfo.color}
                                                        variant="filled"
                                                        size="small"
                                                    />
                                                    <Typography variant="body2">
                                                        {statusInfo.display}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </TableCell>
                                        {Object.keys(validationErrors).length > 0 && (
                                            <TableCell>
                                                {hasError && (
                                                    <Typography variant="caption" color="error">
                                                        {validationErrors[student.id]}
                                                    </Typography>
                                                )}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={Object.keys(validationErrors).length > 0 ? 4 : 3} align="center">
                                    {filteredStudents?.length === 0 ? 'No matching students found' : 'No students available'}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {Object.keys(validationErrors).length > 0 && (
                <Box sx={{ mt: 2, p: 2, bgcolor: 'error.light', borderRadius: 1 }}>
                    <Typography variant="body2" color="error.dark">
                        <strong>Validation Errors:</strong> Please fix the highlighted errors before saving.
                    </Typography>
                    <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
                        {Object.entries(validationErrors).map(([studentId, error]) => {
                            const student = students?.find(s => s.id == studentId);
                            return (
                                <li key={studentId}>
                                    <Typography variant="caption" color="error.dark">
                                        {student ? `${student.firstName} ${student.lastName}: ` : 'Student '}
                                        {error}
                                    </Typography>
                                </li>
                            );
                        })}
                    </ul>
                </Box>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                <Box>
                    {isEditing && (
                        <Typography variant="body2" component="div" color="warning.main">
                            <strong>Note:</strong> You are in edit mode. Changes will be saved when you click "Update Attendance"
                        </Typography>
                    )}
                    {isPastDate() && (
                        <Typography variant="body2" component="div" color="warning.main">
                            <strong>Warning:</strong> You are marking attendance for a past date ({date.format('DD MMM YYYY')})
                        </Typography>
                    )}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {isEditing && (
                        <Button
                            variant="outlined"
                            onClick={handleEditToggle}
                            disabled={loading || submitting}
                            startIcon={<CancelIcon />}
                        >
                            Cancel Edit
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading || submitting || !canEditAttendance || Object.keys(validationErrors).length > 0}
                        size="large"
                        startIcon={isEditing ? <SaveIcon /> : null}
                        color={isEditing ? "warning" : "primary"}
                    >
                        {submitting ? 'Saving...' : isEditing ? 'Update Attendance' : 'Save Attendance'}
                    </Button>
                </Box>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default Attendance;